import React, { useEffect } from 'react';
import closeModal from 'Helpers/ModalHelper';
import useCollection from 'Hooks/useCollection';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import relationships from 'Consts/Relationships';
import MetaCollectionFormDialog from 'Components/UI/Meta/MetaForm/MetaCollectionFormDialog';

import {
  displayErrorMessage,
  displaySuccess,
} from 'Helpers/FacetNotificationManager';

export default function EmergencyFundModal() {
  const { collection, setCollection } = useCollection();
  const { householdResource } = useSimpleHousehold();

  const handleClose = () => {
    closeModal();
  };

  useEffect(() => {
    // Only fetch if you haven't before and you have the required relationship
    if (
      !collection
      && householdResource
      && householdResource.relationship(relationships.emergencyFund)
      && householdResource
        .relationship(relationships.emergencyFund)
        .link('related')
    ) {
      householdResource
        .relationship(relationships.emergencyFund)
        .link('related')
        .Get()
        .then((coll) => {
          if (coll.resources().length() === 0) {
            coll.create({ addToCollection: true });
            coll
              .resources()
              .head()
              .attr('householdId', householdResource.id());
          }
          setCollection(coll);
        })
        .catch((err) => {
          displayErrorMessage(err, err.errors);
        });
    }
  }, [householdResource]);

  const onSuccess = () => {
    displaySuccess('Emergency Fund Saved');
    handleClose();
  };

  const onFailure = (err) => {
    displayErrorMessage(err, err.errors);
  };

  if (!collection) return null;

  return (
    <MetaCollectionFormDialog
      collection={collection}
      onClose={handleClose}
      onFailure={onFailure}
      onSubmit={onSuccess}
      title="Save Emergency Fund"
    />
  );
}
